/**
 * 评测引擎 coreType 枚举
 * 对应评测接口 URL 中的评测类型标识
 */
export const coreTypeEnum = Object.freeze({
  WORD: 'en.word.score', // 单词评测
  SENT: 'en.sent.score', // 句子评测
  PRED: 'en.pred.score', // 段落评测
  ALPHA: 'en.alpha.score', // 音标评测
  WORD_KID: 'en.word_kid.score', //儿童单词评测
  SENT_KID: 'en.sent_kid.score' // 儿童句子评测
})
